if (!customElements.get('khs-merch-rail')) {
  customElements.define('khs-merch-rail', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const viewport = this.querySelector('[data-merch-viewport]');
      const controls = this.querySelector('[data-merch-controls]');
      if (!viewport || !controls) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const previous = controls.querySelector('[data-merch-previous]');
      const next = controls.querySelector('[data-merch-next]');
      const update = () => {
        const max = viewport.scrollWidth - viewport.clientWidth;
        controls.hidden = max <= 1;
        previous.disabled = viewport.scrollLeft <= 1;
        next.disabled = viewport.scrollLeft >= max - 1;
      };
      const move = (direction) => viewport.scrollBy({
        left: direction * viewport.clientWidth * 0.9,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
      previous.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      viewport.addEventListener('scroll', update, { ...options, passive: true });
      viewport.addEventListener('keydown', (event) => {
        if (event.target !== viewport || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') viewport.scrollTo({ left: event.key === 'Home' ? 0 : viewport.scrollWidth, behavior: 'auto' });
        else move(event.key === 'ArrowLeft' ? -1 : 1);
      }, options);
      this.observer = new ResizeObserver(update);
      this.observer.observe(viewport);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  });
}
